var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E3B49",
    d: "M18.667 19.259c-0.178 0-0.296-0.059-0.415-0.178l-2.252-2.252-2.252 2.252c-0.237 0.237-0.593 0.237-0.83 0s-0.237-0.593 0-0.83l2.252-2.252-2.252-2.252c-0.237-0.237-0.237-0.593 0-0.83s0.593-0.237 0.83 0l2.252 2.252 2.252-2.252c0.237-0.237 0.593-0.237 0.83 0s0.237 0.593 0 0.83l-2.252 2.252 2.252 2.252c0.237 0.237 0.237 0.593 0 0.83-0.119 0.119-0.237 0.178-0.415 0.178z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E3B49",
    d: "M16 27.259c-6.222 0-11.259-5.037-11.259-11.259 0-1.956 0.533-3.911 1.481-5.63 0.178-0.296 0.533-0.356 0.83-0.237 0.296 0.178 0.356 0.533 0.237 0.83-0.889 1.541-1.363 3.259-1.363 5.037 0 5.57 4.504 10.074 10.074 10.074s10.074-4.504 10.074-10.074-4.504-10.074-10.074-10.074c-1.778 0-3.496 0.474-5.037 1.363-0.296 0.178-0.652 0.059-0.83-0.237s-0.059-0.652 0.237-0.83c1.719-0.948 3.674-1.481 5.63-1.481 6.222 0 11.259 5.037 11.259 11.259s-5.037 11.259-11.259 11.259z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.94f8cfe610b2760841f01a39e870dd63.svg";
export { ForwardRef as ReactComponent };